
























































































































































































































































































import Vue from "vue";
import { AxiosResponse } from "axios";
import { ValidationObserver } from "vee-validate";
import store from "@/store";
// component
import PageTitle from "@/commons/components/PageTitle.vue";
import DialogCard from "@/commons/components/DialogCard.vue";
import ReportTypeCard from "@/features/analytics/components/ReportTypeCard.vue";
import ReportGeneralSettingCard from "@/features/analytics/components/ReportGeneralSettingCard.vue";
import MobileReportFilteringSelectionCard from "@/features/analytics/components/mobile/ReportFilteringSelectionCard.vue";
import PcReportFilteringSelectionCard from "@/features/analytics/components/pc/ReportFilteringSelectionCard.vue";
import MobileReportSortingSelectionCard from "@/features/analytics/components/mobile/ReportSortingSelectionCard.vue";
import PcReportSortingSelectionCard from "@/features/analytics/components/pc/ReportSortingSelectionCard.vue";
import DownloadingDialogCard from "@/commons/components/downloadingDialogCard.vue";
import downloadLinkDialogCard from "@/commons/components/downloadLinkDialogCard.vue";
// enum
import { Enum } from "@/commons/enums/Type";
import { PeriodEnum } from "@/commons/enums/Period";
import { FilterEnum } from "@/features/analytics/enums/Filter";
import { ReportTypeEnum } from "@/features/analytics/enums/ReportType";
// api
import * as reportApi from "@/features/analytics/axios";
// util
import * as dateHandling from "@/commons/utils/dateHandling";
import * as notifyUtil from "@/commons/utils/notifyUtil";
import * as browserUtil from "@/commons/utils/browserUtil";
import asyncSleep from "@/commons/utils/asyncSleep";
// types
import { LoginUser } from "@/commons/types";
import {
  FiltersInput,
  SortingSelectionItem,
  GetDimensionsResponse,
  GetMetricsResponse,
  EditReportResponse,
  GenerateReportResponse,
  GetReportsFileResponse,
  GetReportResponse,
  UpdateFilterEvent,
} from "@/features/analytics/types";

export default Vue.extend({
  components: {
    "page-title": PageTitle,
    "validation-observer": ValidationObserver,
    "report-type-card": ReportTypeCard,
    "report-general-setting-card": ReportGeneralSettingCard,
    "report-filtering-selection-card-mobile": MobileReportFilteringSelectionCard,
    "report-filtering-selection-card-pc": PcReportFilteringSelectionCard,
    "report-sorting-selection-card-mobile": MobileReportSortingSelectionCard,
    "report-sorting-selection-card-pc": PcReportSortingSelectionCard,
    "dialog-card": DialogCard,
    "downloading-dialog-card": DownloadingDialogCard,
    "download-link-dialog-card": downloadLinkDialogCard,
  },

  props: {
    // NewReportの場合、レポートの新規作成。EditReportの場合、レポートの編集。
    pageType: String,
  },

  data() {
    return {
      loginUser: null as LoginUser | null,
      reportTypeInput: 1 as number,
      reportNameInput: "" as string,
      periodInput: 1 as number,
      filtersInput: [] as FiltersInput[],
      conditionInput: "" as string,
      startDateInput: "" as string,
      endDateInput: "" as string,
      reportType: [
        ReportTypeEnum.PREBID_ANALYTICS,
        ReportTypeEnum.BI_REPORT,
        // GAM レポートは使用しないため一旦選択肢から消去
        // ReportTypeEnum.GOOGLE_AD_MANAGER,
      ] as Enum[],
      dimensionsInput: [] as number[],
      metricsInput: [] as number[],
      isAdhoc: false as boolean,
      // Phase 2 以降
      // notIncludeUsersPub: false as boolean,
      confirmationDialog: false as boolean,
      canLeave: false as boolean,
      nextPath: { name: "" as string },
      loading: true as boolean,
      formLoading: false as boolean,
      showSaveAndDownloadConfirmDialog: false as boolean,
      showAdhocDownloadConfirmDialog: false as boolean,
      reportTypeDialog: false as boolean,
      reportTypeInputDisplay: 1 as number,
      isGenerateReport: false as boolean,
      isDownloadReport: false as boolean,
      isDownloadSuccessfulInSafari: false as boolean,
      downloadUrl: "" as string,
      retryCount: 0 as number,
      downloadPercentage: 0 as number,
      jobStatus: null as number | null,
      jobId: "" as string,
      tmpReportId: 0 as number,
      showUnAuthorizedDialog: false as boolean,
      ownersEmail: "" as string,
      dimensionLoading: false as boolean,
      dimensions: [] as SortingSelectionItem[],
      metricsLoading: false as boolean,
      metrics: [] as SortingSelectionItem[],
      doLogout: false as boolean,
      downloadingDialog: false as boolean,
      isSavingReport: false as boolean,
    };
  },

  computed: {
    title(): string {
      if (this.$route.name === "NewReport") {
        return "New Report";
      } else if (this.$route.name === "EditReport") {
        return "Edit Report";
      }
      return "";
    },
    runReportDisabled(): boolean {
      if (this.$route.name === "NewReport") {
        return true;
      }
      return false;
    },
    isNotChrome(): boolean {
      // NOTE: SafariがUA-CHに対応していないので、UAでChrome以外かどうか判定する.
      const userAgent = window.navigator.userAgent.toLowerCase() as string;
      return userAgent.indexOf("chrome") == -1;
    },
    isMobileDisplay(): boolean {
      return this.$vuetify.breakpoint.name === "xs" || this.$vuetify.breakpoint.name === "sm";
    },
    modalWidth(): string {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "80%";
        case "sm":
          return "65%";
        case "md":
          return "50%";
        case "lg":
          return "45%";
        case "xl":
          return "35%";
      }
      return "50%";
    },
  },

  methods: {
    fetchDimensions() {
      this.dimensionLoading = true;
      reportApi
        .getDimensions(this.reportTypeInput)
        .then((response: AxiosResponse<GetDimensionsResponse>) => {
          this.dimensions = response.data.dimensions;
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.dimensions"));
          }
        })
        .finally(() => {
          this.dimensionLoading = false;
        });
    },
    fetchMetrics() {
      this.metricsLoading = true;
      reportApi
        .getMetrics(this.reportTypeInput)
        .then((response: AxiosResponse<GetMetricsResponse>) => {
          this.metrics = response.data.metrics;
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.metrics"));
          }
        })
        .finally(() => {
          this.metricsLoading = false;
        });
    },
    // 複雑なバリデーション処理
    successfulValidation(): boolean {
      let success = true;

      // 期間選択が日付選択の際のバリデーション
      if (this.periodInput === PeriodEnum.PERIOD_SPECIFICATION.value) {
        // 日付選択の際、開始日が未入力
        if (this.startDateInput === "") {
          notifyUtil.notifyErrorMessage(this.$t("analytics.notify.error.emptyStartDate"));
          success = false;
        }
        // 日付選択の際、終了日が未入力
        if (this.endDateInput === "") {
          notifyUtil.notifyErrorMessage(this.$t("analytics.notify.error.emptyEndDate"));
          success = false;
        }
        // 日付指定の際、開始日と終了日が逆転
        if (Date.parse(this.startDateInput) > Date.parse(this.endDateInput)) {
          notifyUtil.notifyErrorMessage(this.$t("analytics.notify.error.reverseDate"));
          success = false;
        }
        if (this.reportTypeInput === ReportTypeEnum.PREBID_ANALYTICS.value) {
          // 日付指定 かつ Prebid Anayltics の際、開始日が2021年10月01日以前
          if (Date.parse(this.startDateInput) < Date.parse("2021-10-01")) {
            notifyUtil.notifyErrorMessage(
              this.$t("analytics.notify.error.invalidAnalyticsStartDate")
            );
            success = false;
          }

          // 日付指定 かつ Prebid Anayltics の際、範囲が31日間を超えている
          const tmpStartDate = new Date(this.startDateInput);
          const tmpEndDate = new Date(this.endDateInput);
          tmpStartDate.setDate(tmpStartDate.getDate() + 30);
          if (tmpStartDate < tmpEndDate) {
            notifyUtil.notifyErrorMessage(this.$t("analytics.notify.error.limitAnalyticsPeriod"));
            success = false;
          }
        } else if (this.reportTypeInput === ReportTypeEnum.BI_REPORT.value) {
          // 日付指定 かつ Bi Report の際、開始日が2019年04月01日以前
          if (Date.parse(this.startDateInput) < Date.parse("2019-04-01")) {
            notifyUtil.notifyErrorMessage(
              this.$t("analytics.notify.error.invalidScrapingStartDate")
            );
            success = false;
          }

          // 日付指定 かつ Bi Report の際、範囲が過去1年間に絞られていない
          const tmpStartDate = new Date(this.startDateInput);
          const tmpEndDate = new Date(this.endDateInput);
          if (dateHandling.isIncludeLeapYearByStartDate(tmpStartDate)) {
            tmpStartDate.setDate(tmpStartDate.getDate() + 365);
          } else {
            tmpStartDate.setDate(tmpStartDate.getDate() + 364);
          }
          if (tmpStartDate < tmpEndDate) {
            notifyUtil.notifyErrorMessage(this.$t("analytics.notify.error.limitScrapingPeriod"));
            success = false;
          }
        } else if (this.reportTypeInput === ReportTypeEnum.GOOGLE_AD_MANAGER.value) {
          // 日付指定 かつ GAM の際、開始日が2022年2月1日以前
          if (Date.parse(this.startDateInput) < Date.parse("2022-02-01")) {
            notifyUtil.notifyErrorMessage(
              this.$t("analytics.notify.error.invalidAnalyticsStartDate")
            );
            success = false;
          }

          // 日付指定 かつ GAM の際、範囲が1年以内に絞られていない
          const tmpStartDate = new Date(this.startDateInput);
          const tmpEndDate = new Date(this.endDateInput);
          if (dateHandling.isIncludeLeapYearByStartDate(tmpStartDate)) {
            tmpStartDate.setDate(tmpStartDate.getDate() + 365);
          } else {
            tmpStartDate.setDate(tmpStartDate.getDate() + 364);
          }
          if (tmpStartDate < tmpEndDate) {
            notifyUtil.notifyErrorMessage(this.$t("analytics.notify.error.limitAnalyticsPeriod"));
            success = false;
          }
        }
      }

      // レポートタイプが BI Report の際のバリデーション
      let hasDevice = false as boolean;
      let hasBrowser = false as boolean;
      let hasOs = false as boolean;
      if (this.reportTypeInput === ReportTypeEnum.BI_REPORT.value) {
        for (const filter of this.filtersInput) {
          if (filter.filterType === FilterEnum.DEVICE.value) {
            hasDevice = true;
            success = false;
          }
          if (filter.filterType === FilterEnum.BROWSER.value) {
            hasBrowser = true;
            success = false;
          }
          if (filter.filterType === FilterEnum.OS.value) {
            hasOs = true;
            success = false;
          }
        }
        if (hasDevice) {
          notifyUtil.notifyErrorMessage(this.$t("analytics.notify.error.invalidDevice"));
        }
        if (hasBrowser) {
          notifyUtil.notifyErrorMessage(this.$t("analytics.notify.error.invalidBrowser"));
        }
        if (hasOs) {
          notifyUtil.notifyErrorMessage(this.$t("analytics.notify.error.invalidOs"));
        }
      }

      // ディメンションが空
      if (this.dimensionsInput.length === 0) {
        notifyUtil.notifyErrorMessage(this.$t("analytics.notify.error.emptyDimension"));
        success = false;
      }

      // メトリクスが空
      if (this.metricsInput.length === 0) {
        notifyUtil.notifyErrorMessage(this.$t("analytics.notify.error.emptyMetrics"));
        success = false;
      }

      return success;
    },
    clickOkOnDialog() {
      this.confirmationDialog = false;
      this.showUnAuthorizedDialog = false;
      this.canLeave = true;

      if (this.doLogout) {
        this.$emit("logout");
      } else {
        this.$router.push(this.nextPath);
      }
    },
    clickCancelOnDialog() {
      this.confirmationDialog = false;
      this.doLogout = false;
    },
    showSaveDialog() {
      this.isAdhoc = false;
      this.showSaveAndDownloadConfirmDialog = true;
    },
    showAdhocDialog() {
      // NOTE: 保存せず実行の処理時にバリデーションを無効化させる実装をしたところうまく反映されなかったため、
      //       モーダルの開閉時に isAdhoc の true/false を制御するよう実装
      this.isAdhoc = true;
      this.showAdhocDownloadConfirmDialog = true;
    },
    closeAdhocDialog() {
      this.isAdhoc = false;
      this.showAdhocDownloadConfirmDialog = false;
    },
    closeDownloadInSafari() {
      this.isAdhoc = false;
      this.showAdhocDownloadConfirmDialog = false;
      this.showSaveAndDownloadConfirmDialog = false;
      this.isDownloadSuccessfulInSafari = false;
    },
    clickOkOnReportTypeDialog() {
      // レポートタイプを変更
      this.reportTypeInput = this.reportTypeInputDisplay;

      // ディメンションとメトリクスを再取得
      this.fetchDimensions();
      this.fetchMetrics();

      // 選択した項目を全削除
      this.reportNameInput = "";
      this.periodInput = 1;
      this.filtersInput.length = 0;
      this.dimensionsInput.splice(0);
      this.metricsInput.splice(0);

      // 期間を再計算
      const date = dateHandling.getDateByPeriodType(this.periodInput);
      this.startDateInput = date.startDate;
      this.endDateInput = date.endDate;

      // モーダルを閉じる
      this.reportTypeDialog = false;
    },
    canAction(): boolean {
      return this.jobStatus !== 1;
    },
    // ログインユーザがレポートを保存できるかどうか
    canSave(): boolean {
      // レポート新規作成時は true
      if (this.$route.name === "NewReport") {
        return true;
      }
      // レポート編集時はログインユーザとレポート作成者が同じ場合 true
      return this.loginUser?.email === this.ownersEmail;
    },
    clickCancelOnReportTypeDialog() {
      // レポートタイプコンポーネントで表示するレポートタイプを前の状態に戻す
      this.reportTypeInputDisplay = this.reportTypeInput;

      // モーダルを閉じる
      this.reportTypeDialog = false;
    },
    // 保存
    clickSave() {
      (this.$refs.form as InstanceType<typeof ValidationObserver>)
        .validate()
        .then(async (success: boolean) => {
          if (!success) {
            notifyUtil.notifyErrorMessage(this.$t("analytics.notify.error.validateError"));
            return;
          }
          if (!this.successfulValidation()) {
            return;
          }

          this.formLoading = true;
          this.isAdhoc = false;
          if (this.$route.name === "NewReport") {
            await this.saveReportSetting()
              .then(() => {
                notifyUtil.notifySuccessMessage(this.$t("analytics.notify.success.save"));
                this.canLeave = true;
                this.$router.push({ name: "Analytics" });
              })
              .catch(error => {
                if (error.response.status === 401) {
                  notifyUtil.notifyErrorMessage(
                    this.$t("general.notify.error.request.sessionExpired")
                  );
                  this.$router.push({ name: "Login" });
                } else {
                  notifyUtil.notifyErrorMessage(this.$t("analytics.notify.error.failedSave"));
                }
              })
              .finally(() => {
                this.formLoading = false;
              });
          } else if (this.$route.name === "EditReport") {
            await this.updateReport()
              .then(() => {
                notifyUtil.notifySuccessMessage(this.$t("analytics.notify.success.save"));
                this.canLeave = true;
                this.$router.push({ name: "Analytics" });
              })
              .catch(error => {
                if (error.response.status === 401) {
                  notifyUtil.notifyErrorMessage(
                    this.$t("general.notify.error.request.sessionExpired")
                  );
                  this.$router.push({ name: "Login" });
                } else {
                  notifyUtil.notifyErrorMessage(this.$t("analytics.notify.error.failedSave"));
                }
              })
              .finally(() => {
                this.formLoading = false;
              });
          }
        });
    },

    // 保存して実行
    clickSaveAndRun() {
      (this.$refs.form as InstanceType<typeof ValidationObserver>)
        .validate()
        .then(async (success: boolean) => {
          if (!success) {
            this.showSaveAndDownloadConfirmDialog = false;
            notifyUtil.notifyErrorMessage(this.$t("analytics.notify.error.validateError"));
            return;
          }
          if (!this.successfulValidation()) {
            return;
          }
          this.isSavingReport = true;
          this.downloadingDialog = true;
          this.formLoading = true;
          this.showSaveAndDownloadConfirmDialog = false;
          if (this.$route.name === "NewReport") {
            await this.saveReportSetting()
              .then((res: AxiosResponse<EditReportResponse>) => {
                this.tmpReportId = res.data.reportId;
                notifyUtil.notifySuccessMessage(this.$t("analytics.notify.success.save"));
              })
              .catch(error => {
                if (error.response.status === 401) {
                  notifyUtil.notifyErrorMessage(
                    this.$t("general.notify.error.request.sessionExpired")
                  );
                  this.$router.push({ name: "Login" });
                } else {
                  notifyUtil.notifyErrorMessage(
                    this.$t("analytics.notify.error.failedSaveAndDownload")
                  );
                }
                return;
              })
              .finally(() => {
                this.formLoading = false;
                this.isSavingReport = false;
              });
          } else if (this.$route.name === "EditReport") {
            await this.updateReport()
              .then(() => {
                notifyUtil.notifySuccessMessage(this.$t("analytics.notify.success.save"));
                this.tmpReportId = Number(this.$route.params.reportId);
              })
              .catch(error => {
                if (error.response.status === 401) {
                  notifyUtil.notifyErrorMessage(
                    this.$t("general.notify.error.request.sessionExpired")
                  );
                  this.$router.push({ name: "Login" });
                } else {
                  notifyUtil.notifyErrorMessage(
                    this.$t("analytics.notify.error.failedSaveAndDownload")
                  );
                }
                return;
              })
              .finally(() => {
                this.formLoading = false;
                this.isSavingReport = false;
              });
          }
          await this.generateReport();
        });
    },

    // 保存せず実行
    clickAdhocRun() {
      (this.$refs.form as InstanceType<typeof ValidationObserver>)
        .validate()
        .then(async (success: boolean) => {
          if (!success) {
            this.showAdhocDownloadConfirmDialog = false;
            notifyUtil.notifyErrorMessage(this.$t("analytics.notify.error.validateError"));
            return;
          }
          if (!this.successfulValidation()) {
            return;
          }

          this.downloadingDialog = true;
          this.showAdhocDownloadConfirmDialog = false;
          this.formLoading = true;
          await this.saveReportSetting()
            .then((res: AxiosResponse<EditReportResponse>) => {
              this.tmpReportId = res.data.reportId;
            })
            .catch(error => {
              if (error.response.status === 401) {
                notifyUtil.notifyErrorMessage(
                  this.$t("general.notify.error.request.sessionExpired")
                );
                this.$router.push({ name: "Login" });
              } else {
                notifyUtil.notifyErrorMessage(
                  this.$t("analytics.notify.error.failedSaveAndDownload")
                );
              }
              return;
            })
            .finally(() => {
              this.formLoading = false;
            });
          await this.generateReport();
        });
    },

    /**
     * Adhocフラグが立っていない場合はレポート名をreturnする.
     * Adhocフラグが立っている場合はレポートタイプに応じて下記のいずれかをreturnする.
     * 日付のfrom-toは期間種別に応じてyyyy-MM-dd形式で保管される.
     * as_analytics_report(yyyy-mm-dd to yyyy-mm-dd)
     * as_bi_report(yyyy-mm-dd to yyyy-mm-dd)
     */
    buildReportName() {
      let tmpReportName = this.reportNameInput as string;
      if (this.isAdhoc) {
        tmpReportName = "as_";
        if (this.reportTypeInput === ReportTypeEnum.PREBID_ANALYTICS.value) {
          tmpReportName += "analytics_report";
        } else if (this.reportTypeInput === ReportTypeEnum.BI_REPORT.value) {
          tmpReportName += "bi_report";
        } else if (this.reportTypeInput === ReportTypeEnum.GOOGLE_AD_MANAGER.value) {
          tmpReportName += "google_ad_manager_report";
        }
        tmpReportName += "(";
        if (this.periodInput !== PeriodEnum.PERIOD_SPECIFICATION.value) {
          const date = dateHandling.getDateByPeriodType(this.periodInput);
          tmpReportName += date.startDate + "-" + date.endDate + ")";
        } else {
          tmpReportName += this.startDateInput + "-" + this.endDateInput + ")";
        }
      }
      return tmpReportName;
    },

    async saveReportSetting() {
      this.formLoading = true;
      let data = {
        reportName: this.buildReportName(),
        reportType: this.reportTypeInput,
        periodType: this.periodInput,
        startDate: this.startDateInput,
        endDate: this.endDateInput,
        filters: this.filtersInput,
        dimensions: this.dimensionsInput,
        metrics: this.metricsInput,
        isAdhoc: this.isAdhoc,
      };

      // Period Type が期間選択以外
      if (this.periodInput !== PeriodEnum.PERIOD_SPECIFICATION.value) {
        const date = dateHandling.getDateByPeriodType(this.periodInput);
        data.startDate = date.startDate;
        data.endDate = date.endDate;
      }

      return reportApi.saveReport(data);
    },

    async updateReport() {
      let data = {
        reportId: Number(this.$route.params.reportId),
        reportName: this.reportNameInput,
        reportType: this.reportTypeInput,
        periodType: this.periodInput,
        startDate: this.startDateInput,
        endDate: this.endDateInput,
        filters: this.filtersInput,
        dimensions: this.dimensionsInput,
        metrics: this.metricsInput,
        isAdhoc: false,
      };

      // Period Type が期間選択以外
      if (this.periodInput !== PeriodEnum.PERIOD_SPECIFICATION.value) {
        const date = dateHandling.getDateByPeriodType(this.periodInput);
        data.startDate = date.startDate;
        data.endDate = date.endDate;
      }

      return reportApi.updateReport(data, this.$route.params.reportId);
    },

    generateReport() {
      this.isGenerateReport = true;
      reportApi
        .generateReport(Number(this.tmpReportId), this.$store.state.currency)
        .then((res: AxiosResponse<GenerateReportResponse>) => {
          this.jobId = res.data.jobId;
          this.isGenerateReport = false;
          this.downloadReport();
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else {
            notifyUtil.notifyErrorMessage(this.$t("analytics.notify.error.failedGenerate"));
            this.isGenerateReport = false;
          }
        });
    },

    async downloadReport() {
      if (this.retryCount > 10) {
        notifyUtil.notifyErrorMessage(this.$t("analytics.notify.error.failedDownload"));
        this.retryCount = 0;
        this.isDownloadReport = false;
        return;
      }
      // 5 seconds × retryCount 遅延
      await asyncSleep(this.retryCount * 5000);

      // ダウンロード開始時はDL進行率を 0 に初期化
      if (!this.isDownloadReport) this.downloadPercentage = 0;

      this.isDownloadReport = true;
      this.retryCount++;
      if (this.retryCount > 1) this.downloadPercentage += 10;

      await reportApi
        .getReportsFile(this.jobId)
        .then(async (res: AxiosResponse<GetReportsFileResponse>) => {
          if (res.status === 200) {
            // report_url に null が入る時
            if (res.data.report_url === null) {
              // リトライ回数が 10 を超えた場合エラーを返す
              if (this.retryCount > 10) {
                notifyUtil.notifyErrorMessage(this.$t("analytics.notify.error.failedDownload"));
                this.retryCount = 0;
                this.isDownloadReport = false;
                this.downloadPercentage = 0;
                return;
              }
              // リトライ
              this.downloadReport();
              return;
            }

            // 処理成功時
            this.downloadPercentage = 100;
            await asyncSleep(1000);
            notifyUtil.notifySuccessMessage(this.$t("analytics.notify.success.download"));
            // Chrome 以外はダウンロードリンクを表示
            if (browserUtil.isNotChrome()) {
              this.downloadUrl = res.data.report_url;
              this.isDownloadSuccessfulInSafari = true;
              this.downloadingDialog = false;
            }
            // Chrome は自動的にダウンロードされるためそのままモーダルを閉じる
            else {
              const fileName = this.reportNameInput + ".csv";
              const link = document.createElement("a");
              link.href = res.data.report_url;
              link.download = fileName;
              document.body.appendChild(link);
              link.click();
              this.downloadingDialog = false;
              this.showSaveAndDownloadConfirmDialog = false;
              this.showAdhocDownloadConfirmDialog = false;
            }
            this.isDownloadReport = false;
            this.retryCount = 0;
            this.downloadPercentage = 0;
          } else if (res.status === 202) {
            this.downloadReport();
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else {
            notifyUtil.notifyErrorMessage(this.$t("analytics.notify.error.failedDownload"));
            this.retryCount = 0;
            this.isDownloadReport = false;
            this.downloadPercentage = 0;
          }
        });
    },

    async fetchData() {
      // loading状態にする
      this.loading = true;
      // ログインユーザーの情報取得
      this.loginUser = store.getters["auth/getLoginUser"];

      // 更新画面の場合、レポート1件取得するAPIを叩く
      if (this.$route.name === "EditReport") {
        await reportApi
          .getReport(this.$route.params.reportId)
          .then((response: AxiosResponse<GetReportResponse>) => {
            this.reportNameInput = response.data.reportName;
            this.reportTypeInput = response.data.reportType;
            this.reportTypeInputDisplay = response.data.reportType;
            this.periodInput = response.data.periodType;
            this.jobStatus = response.data.jobStatus;
            if (response.data.periodType === PeriodEnum.PERIOD_SPECIFICATION.value) {
              this.startDateInput = response.data.startDate;
              this.endDateInput = response.data.endDate;
            } else {
              const date = dateHandling.getDateByPeriodType(response.data.periodType);
              this.startDateInput = date.startDate;
              this.endDateInput = date.endDate;
            }
            this.ownersEmail = response.data.ownersEmail;

            // ディメンションの整形と追加
            const dimensionsResponse = response.data.dimensions;
            dimensionsResponse.sort((a, b) => {
              if (a.outputOrder < b.outputOrder) return -1;
              if (a.outputOrder > b.outputOrder) return 1;
              return 0;
            });
            dimensionsResponse.forEach(item => {
              this.dimensionsInput.push(item.dimensionId);
            });

            // メトリクスの整形と追加
            const metricsResponse = response.data.metrics;
            metricsResponse.sort((a, b) => {
              if (a.outputOrder < b.outputOrder) return -1;
              if (a.outputOrder > b.outputOrder) return 1;
              return 0;
            });
            metricsResponse.forEach(item => {
              this.metricsInput.push(item.metricsId);
            });

            // フィルタの追加
            response.data.filters.forEach(value => {
              this.filtersInput.push({
                filterType: value.filterType,
                conditionId: value.conditionId,
                conditionName: value.conditionName,
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status === 401) {
                notifyUtil.notifyErrorMessage(
                  this.$t("general.notify.error.request.sessionExpired")
                );
                this.$router.push({ name: "Login" });
              } else if (error.response.status === 403) {
                this.nextPath.name = "Analytics";
                this.showUnAuthorizedDialog = true;
              } else {
                notifyUtil.notifyErrorMessage(
                  this.$t("general.notify.error.request.analyticsReport")
                );
              }
            } else {
              notifyUtil.notifyErrorMessage(
                this.$t("general.notify.error.request.analyticsReport")
              );
            }
          });
      }

      if (this.$route.name === "NewReport") {
        const date = dateHandling.getDateByPeriodType(this.periodInput);
        this.startDateInput = date.startDate;
        this.endDateInput = date.endDate;
      }

      this.fetchDimensions();
      this.fetchMetrics();

      // 全てのデータが更新された時点でloading完了
      this.loading = false;
    },
    updateFilter(event: UpdateFilterEvent) {
      let tmpArray = this.filtersInput.filter((item: FiltersInput) => {
        return item.filterType !== event.filterType;
      });
      this.filtersInput = tmpArray.concat(event.newValue);
    },
    clearFilter(filterType: number) {
      this.filtersInput = this.filtersInput.filter((item: FiltersInput) => {
        return item.filterType !== filterType;
      });
    },
    clearAllFilters() {
      this.filtersInput.splice(0);
    },
    checkMove() {
      this.doLogout = true;
      this.confirmationDialog = true;
    },
  },

  created() {
    this.fetchData();
  },

  watch: {
    periodInput: async function () {
      if (this.periodInput !== PeriodEnum.PERIOD_SPECIFICATION.value) {
        const date = dateHandling.getDateByPeriodType(this.periodInput);
        this.startDateInput = date.startDate;
        this.endDateInput = date.endDate;
      }
    },
  },

  /**
   * このコンポーネントから離れる時に発火する.
   * 遷移フラグが立っているかChrome以外のブラウザの場合はそのまま遷移させ、遷移フラグが立っていなければ遷移を中断し確認ダイアログを表示してから遷移する.
   */
  beforeRouteLeave(to, from, next) {
    if (this.canLeave || this.isNotChrome) {
      next();
      return;
    }
    this.confirmationDialog = true;
    this.nextPath.name = String(to.name);
    next(false);
  },
});
